import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Molina Marketplace",
  shortName: "Molina Marketplace",
  slug: "molina-marketplace-insurance",
  seoTitle: "Molina Marketplace TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have a Molina Marketplace plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your ACA marketplace plan in Coral Springs, FL.",
  seoKeywords:
    "Molina Marketplace TMS coverage, Molina TMS therapy, Molina ACA depression treatment Florida, Molina Marketplace mental health benefits, Molina SAINT TMS",
  planType: "Health Insurance Marketplace plan (ACA / Healthcare.gov)",
  planRegion: "Florida and select states",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits as an essential health benefit, including mental health services",
  planSpecificIntro:
    "Molina Healthcare offers individual and family health insurance plans through the Health Insurance Marketplace (Healthcare.gov). These ACA-compliant plans include behavioral health benefits as one of the ten essential health benefits, which may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Because Molina Marketplace plans come in different metal tiers, coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific plan tier, deductible, and network.",
  officialResourceUrl: "https://www.molinahealthcare.com/",
  officialResourceLabel: "Molina Marketplace plans",
};

export const MolinaMarketplaceInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default MolinaMarketplaceInsurance;
